module.exports = __webpack_public_path__ + "icomoon.svg?78ac7379697f3b0a9d083a0984193427";